

import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import * as tf from '@tensorflow/tfjs';
import { ReadMoreComponent } from '../read-more/read-more.component';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { environment } from '../../../../../environments/environment';
import { GroupbyFPipe } from '../../groupby-f.pipe';

import { runInThisContext } from 'vm';
import { DialogExamSubmitComponent } from './dialog-exam-submit/dialog-exam-submit.component';
import { Dialog } from '@angular/cdk/dialog';

import moment from 'moment';
import { DialogReportQuestionComponent } from './dialog-report-question/dialog-report-question.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { fromEvent, interval, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-exam',
  standalone: true,
  imports: [RouterModule, CommonModule, ReadMoreComponent, GroupbyFPipe, FormsModule, ReactiveFormsModule, NgxStarRatingModule],
  templateUrl: './exam.component.html',
  styleUrl: './exam.component.css'
})
export class ExamComponent {
  @ViewChild('CameraId') _camera!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') _canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('frame') _frame!: ElementRef<HTMLDivElement>;
  private notifySub!: Subscription;
  stream!: MediaStream;
  PREP_UserInfo: any = null;
  capturedImage: string | null = null;
  faceCount: any = null;
  msg: any = null;
  ReadMoreText: string = "I confirm that my device is in proper working condition and that I am not using prohibited gadgets such as mobile phones, Bluetooth devices, or any other communication tools during the exam. I understand that failure to follow the given instructions may affect my exam result and my eligibility to take future PowerPerp Mock Tests. The child and parent agree that PowerPerp shall not be held responsible for any loss or damage arising from the use of, or reliance on, this platform. PowerPerp’s decision regarding the result will be final and binding. The data submitted by the applicant may be used by PowerPerp for assessment and communication purposes. By proceeding, I acknowledge that I have read and understood the instructions, navigation rules, and terms & conditions. I also agree that SilverZone will not be liable for any damages of any kind (direct, indirect, incidental, or consequential) arising from the use of this site.";
  CameraList: any[] = [];
  CameraSource: string = '';
  questionList: any = [];
  Index: any;
  Question: any = null;
  TimeTaken: any = 0;
  isPageLoad: any;
  Disclamer: any = true;
  ExamStatus: any = "Instruction"


  Instruction: any = null
  PREP_ExamDetails: any = null;
  BaseURLForQuestion: any = null;

  SECONDS_COUNT: any;
  Pres_Total_Second: any;
  Timer_Interval: any;
  Timer: any;
  ExamCode: any = null;

  feedbackForm: any;

  Window_blur: any;
  Window_focus: any;

  onlineEvent: any;
  offlineEvent: any;

  FaceMatching_Interval: any;

  totalMarks: any;
  elem: any;
  constructor(
    private _svc: SharedService,
    private _dialog: Dialog,
    private _fb: FormBuilder,
    private _toastr: ToastrService,
    private _routr: Router,


  ) {

    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;
    })

    this.PREP_ExamDetails = JSON.parse(localStorage.getItem('PREP_ExamDetails') || "{}");


    this.BaseURLForQuestion = environment.BaseURLForQuestion;

    //this.ExamStatus = "ExamSubmited"
  }
  get _form() { return this.feedbackForm.controls; }


  async ngOnInit(): Promise<void> {
    if (this.PREP_ExamDetails == null || this.PREP_ExamDetails == undefined || this.PREP_ExamDetails.eventLetter == undefined) {
      this._routr.navigateByUrl('/MyMockTest');

    }
    this.Get_Instruction();
    this.feedbackForm = this._fb.group({
      Remarks: ['', Validators.compose([Validators.required, Validators.maxLength(250)])],
      rating: ['', Validators.required],
    })

    this._svc.GetCameraList().then((data: any) => {

      this.CameraList = data

      setTimeout(async () => {
        if (this.CameraList.length > 0) {
          this.CameraSource = this.CameraList[0].value;
          this._svc.openCamera(this._camera, this.CameraSource);
          await this._svc.loadModels();
        }
      }, 100);

    });

    var messaage = "";
    var InDate_Time: any;
    var OutDate_Time: any;


    this.Window_blur = fromEvent(window, 'blur').subscribe((event) => {
      OutDate_Time = moment().format('YYYY-MM-DDTHH:mm:ss');
      messaage = 'You have been out of the exam window at from ' + moment().format('hh:mm:ss');
    });
    this.Window_focus = fromEvent(window, 'focus').subscribe((event) => {
      InDate_Time = moment().format('YYYY-MM-DDTHH:mm:ss');
      messaage += ' to ' + moment().format('hh:mm:ss') + '<br/><strong>Log has been maintained.</strong>';
      if (this.ExamStatus == "Start") {
        this._toastr.error(messaage, 'NOTIFICATION', { timeOut: 4000 });

        var _obj = {
          InDate_Time: InDate_Time,
          OutDate_Time: OutDate_Time,
          PowerPrepStatusId: this.PREP_ExamDetails.PowerPrepStatusId
        }


        this._svc.POST(_obj, '/ManageMock/Save_WindowChange').subscribe(response => {
          if (response.result == "success") {
            setTimeout(() => {
              //document.location.reload();
            }, 1000);
          }
        });
      }
    });

    this.onlineEvent = fromEvent(window, 'online').subscribe((event) => {
      this._toastr.success('Connected to internet! You are online', 'NOTIFICATION', { timeOut: 1500 });
    });
    this.offlineEvent = fromEvent(window, 'offline').subscribe((event) => {
      this._toastr.error('Connected to internet! You are online', 'NOTIFICATION', { timeOut: 1500 });
    });


    this.notifySub = interval(7 * 60 * 1000).subscribe(() => {
      this._svc.Notification(
        'error',
        'You are being monitored. Any unfair practice will lead to disqualification.'
      );
    });


  }
  // async ngAfterViewInit() {
  //   setTimeout(async () => {
  //     
  //     this.CameraSource = this.CameraList[0].value;
  //     this._svc.openCamera(this._camera, this.CameraSource);
  //     await this._svc.loadModels();
  //   }, 100);
  // }

  ngOnDestroy(): void {
    this._svc.closeCamera();

    this.Window_blur.unsubscribe();
    this.Window_focus.unsubscribe();

    this.onlineEvent.unsubscribe();
    this.offlineEvent.unsubscribe();

    if (this.notifySub) {
      this.notifySub.unsubscribe();
    }

  }

  Get_Instruction() {

    this._svc.GET(API_End_Point.Get_Instruction_For_Mock(this.PREP_ExamDetails.eventLetter, this.PREP_ExamDetails.classId, '')).subscribe(res => {
      this.Instruction = res.data;
      //this.FaceMatching();
    });
  }

  async I_am_ready_to_begin() {
    var destinationBase64 = await this._svc.captureImage(this._canvas, this._camera);
    this.msg = ""
    this._svc.Show_Loader();
    //if (await this._svc.faceMatchWithBase64(this.PREP_UserInfo.profilePic, destinationBase64)) {
    this._startExam();
    // } else {
    //   this.msg = "Face verification failed: the image does not match the student photo.";
    // }
    this._svc.Hide_Loader();
  }

  _startExam() {
    debugger
    var _obj = {
      ChildId: this.PREP_ExamDetails.ChildId,
      EventLetter: this.PREP_ExamDetails.eventLetter,
      FYear: '2025-26',
      ClassId: this.PREP_ExamDetails.classId,
      DeviceInfo: JSON.stringify(this._svc.DeviceInfo()),
      Stream: null,
      MockSet: this.PREP_ExamDetails.MockSet,
      UID: this._svc.GenerateUniqueID()
    }
    this._svc.POST(_obj, API_End_Point.StartMockTest).subscribe(res => {

      if (res.result == 'success') {

        this.PREP_ExamDetails = JSON.parse(localStorage.getItem('PREP_ExamDetails') || "{}");
        this.PREP_ExamDetails.PowerPrepStatusId = res.PowerPrepStatusId;
        localStorage.setItem('PREP_ExamDetails', JSON.stringify(this.PREP_ExamDetails));
        debugger
        this.questionList = res.questionList;
        this.ExamCode = res.ExamCode;

        if (localStorage.getItem(this.ExamCode) != null) {

          var attendedQuestion = JSON.parse(localStorage.getItem(this.ExamCode) || "[]");

          for (let i = 0; i < attendedQuestion.length; i++) {
            var _flt_data = this.questionList.filter((x: any) => x.QuestionId == attendedQuestion[i].QuestionId);
            if (_flt_data != null) {

              _flt_data[0].AnsId = attendedQuestion[i].AnsId;
              _flt_data[0].Seen = attendedQuestion[i].Seen;
              _flt_data[0].TimeTaken = attendedQuestion[i].TimeTaken;
              _flt_data[0].IsDought = attendedQuestion[i].IsDought;
              _flt_data[0].IsMarkForReview = attendedQuestion[i].IsMarkForReview;
            }
          }
        }

        var _direction = this.questionList.filter((x: any) => x.ParagraphId > 0);



        //localStorage.setItem('userInfo', JSON.stringify(this.UserInfo))


        for (let i = 0; i < _direction.length; i++) {
          var _flt_data = this.questionList.filter((x: any) => x.ParagraphId == _direction[i].ParagraphId);
          var Generate_Direction = ''
          Generate_Direction = 'Direction for QNo. ' + _flt_data[0].QNo + ' To ' + _flt_data[_flt_data.length - 1].QNo;
          for (let j = 0; j < _flt_data.length; j++) {
            _flt_data[j].Direction = Generate_Direction
          }
        }


        for (let i = 0; i < this.questionList.length; i++) {
          this.questionList[i].Pres_AnsId = this.questionList[i].AnsId;

          if (this.questionList[i].TimeTaken == undefined)
            this.questionList[i].TimeTaken = 0;
          else
            this.questionList[i].TimeTaken += 0;
          this.questionList[i].Ques_Option = []
          this.questionList[i].Ques_Option.push({
            OptionId: this.questionList[i].A_OptId,
            OptionText: this.questionList[i].A_OptText,
            OptionImage: this.questionList[i].A_OptIMG,
            OptionVoice: this.questionList[i].A_OptionVoice

          });

          this.questionList[i].Ques_Option.push({
            OptionId: this.questionList[i].B_OptId,
            OptionText: this.questionList[i].B_OptText,
            OptionImage: this.questionList[i].B_OptIMG,
            OptionVoice: this.questionList[i].B_OptionVoice

          });
          this.questionList[i].Ques_Option.push({
            OptionId: this.questionList[i].C_OptId,
            OptionText: this.questionList[i].C_OptText,
            OptionImage: this.questionList[i].C_OptIMG,
            OptionVoice: this.questionList[i].C_OptionVoice

          });

          this.questionList[i].Ques_Option.push({
            OptionId: this.questionList[i].D_OptId,
            OptionText: this.questionList[i].D_OptText,
            OptionImage: this.questionList[i].D_OptIMG,
            OptionVoice: this.questionList[i].D_OptionVoice

          });
        };

        this.Index = -1;
        this.Next();
        this.ExamStatus = "Start"
        setTimeout(async () => {
          this._svc.closeCamera();
          this._svc.openCamera(this._camera, this.CameraSource);
          this.Pres_Total_Second = res.Minues * 60;
          this.Start_Timer(res.Seconds);

          this._svc.fullScreen();
          this._svc.Set_ExamStatus(true);
          var max = 1;
          var min = 6;
          var Random_Minute = Math.floor(Math.random() * (max - min + 1) + min)

          this.FaceMatching_Interval = setInterval(() => {
            if (this.ExamStatus == "Start")
              this.FaceMatching();
            else
              clearInterval(this.FaceMatching_Interval);
          }, Random_Minute * 60000);

          var TimeTaken_Interval = setInterval(() => {
            if (this.ExamStatus == "Start")
              this.TimeTaken = this.TimeTaken + 1;
            else
              clearInterval(TimeTaken_Interval);
          }, 1000);
        }, 100);


        //Random_Minute * 60000
      }
      else
        this._svc.Notification(res.result, res.message);
    });
  }


  Previous() {
    this._save_Answer(this.Question);
    // if (this.Index == 0)
    //   return false;

    if (this.Index > 0) {
      this.Index -= 1;
      this.Question = this.questionList[this.Index];
    }
  }

  Next(): void {
    this._save_Answer(this.Question);

    // if (this.Index == (this.questionList.length - 1))
    //   return false;

    if (this.Index < this.questionList.length) {
      this.Index += 1;
      this.Question = this.questionList[this.Index];
    }
  }

  _save_Answer(obj: any) {
    try {

      window.scrollTo(500, 0);
      //&& this.Question.AnsId > 0
      if (this.Question.AnsId > 0) {
        this.Question.IsMarkForReview = false;
      }

      this.questionList[this.Index].Seen = (this.Question.AnsId > 0 ? false : true);
      this.questionList[this.Index].AnsId = this.Question.AnsId;
      this.questionList[this.Index].TimeTaken = this.questionList[this.Index].TimeTaken + this.TimeTaken;

      this.questionList[this.Index].IsDought = this.Question.IsDought;
      this.questionList[this.Index].IsMarkForReview = this.Question.IsMarkForReview;


      localStorage.setItem(this.ExamCode, JSON.stringify(this.questionList))
      this.TimeTaken = 0;
    }
    catch (e) {

    }
  }

  Dought_In_Question(Question: any) {
    this._dialog.open(DialogReportQuestionComponent, {
      data: null
    }).closed.subscribe((res: any) => {

      if (res.result == "success") {
        Question.IsDought = res.IsDought;
        localStorage.setItem(this.ExamCode, JSON.stringify(this.questionList))
      }
    });
  }

  Mark_For_Review() {
    try {
      this.Question.IsMarkForReview = !this.Question.IsMarkForReview;
      if (this.Question.IsMarkForReview)
        this._svc.Notification("success", "Question has been marked for review. Check Section.<br/> Click again to Un-Mark.");
      else
        this._svc.Notification("success", "Question has been Un-marked for review.");

    }

    catch (err) {
    }
  }
  Play($event: any, data: any, Path: any, IsPara: any) {

    // this.Pred_audio.pause();
    // if (IsPara) {
    //   if (data.Para_audio == undefined) {
    //     data.Para_audio = new Audio(Path);

    //   }
    //   if (data.Para_audio.duration > 0 && !data.Para_audio.paused)
    //     data.Para_audio.pause();
    //   else
    //     data.Para_audio.play();
    //   this.Pred_audio = data.Para_audio;
    // } else {
    //   if (data.audio == undefined) {
    //     data.audio = new Audio(Path);

    //   }
    //   if (data.audio.duration > 0 && !data.audio.paused)
    //     data.audio.pause();
    //   else
    //     data.audio.play();

    //   this.Pred_audio = data.audio;
    // }



    $event.stopPropagation();
  }

  SetCamera(_CameraSource: any) {
    this._svc.openCamera(this._camera, this.CameraSource);
  }

  getClass(_qno: any) {

    var classList = 'btn';
    if (_qno.AnsId > 0) {
      classList += ' btn-attempt';
    } else if (_qno.IsMarkForReview > 0) {
      classList += ' btn-marked-for-review';
    } else if (_qno.Seen == true) {
      classList += ' btn-seen';
    }
    return classList;
  }
  ShowQNo(qno: any) {
    this._save_Answer(this.Question);
    this.Index = qno - 1;
    this.Question = this.questionList[this.Index];
  }

  Start_Timer(Seconds: number) {

    //this._sharedService.set_IsStart(true);
    //this.Object.IsStart = true;
    this.SECONDS_COUNT = Seconds;


    this.Timer_Interval = setInterval(() => {

      this.SECONDS_COUNT = (this.SECONDS_COUNT - 1);

      var duration = moment.duration(this.SECONDS_COUNT, 'seconds');
      this.Timer = moment.utc(duration.asMilliseconds()).format('mm:ss');


      // if (this.Object.IsFinish == false)
      //   this._sharedService.set_Timer(Timer);
      if (this.SECONDS_COUNT == 300)
        this._svc.Notification("error", "Last 5 Minutes Remaining");

      if (this.SECONDS_COUNT == 120)
        this._svc.Notification("error", "Last 2 Minutes Remaining");
      if (this.SECONDS_COUNT == 0) {
        this.ExamSubmit(false)
        clearInterval(this.Timer_Interval);
      }

    }, 1000);
  }

  Finish(_isFinish: any) {
    var _obj = {
      questionList: this.questionList,
      Enable_Yes_For_Submit: false
    }

    if ((this.Pres_Total_Second - 300) <= this.SECONDS_COUNT) {
      _obj.Enable_Yes_For_Submit = false;
    }
    else {
      _obj.Enable_Yes_For_Submit = true;
    }

    this._dialog.open(DialogExamSubmitComponent, {
      data: _obj
    }).closed.subscribe((res: any) => {

      if (res.result == "ExamSubmit") {
        this.ExamSubmit(true)
      }
    });
  }

  ExamSubmit(IsManual: any) {
    try {

      this.totalMarks = 0;
      var _fltr_data = this.questionList.filter((x: any) => x.AnsId == x.CorrectAnsId);
      _fltr_data.forEach((item: any) => {
        this.totalMarks += item.MarksPerQuestion;
      });

      // this.PREP_ExamDetails = JSON.parse(localStorage.getItem('PREP_ExamDetails') || "{}");
      //   this.PREP_ExamDetails.totalMarks = this.totalMarks;
      //   localStorage.setItem('PREP_ExamDetails', JSON.stringify(this.PREP_ExamDetails));

      // localStorage.setItem('totalMarks', this.totalMarks);


      const body = {
        ExamCode: this.ExamCode,
        IsManual: IsManual,
        QuestionList: this.questionList.map((q: any) => ({
          QNO: q.QNo,
          QuestionId: q.QuestionId,
          AnsId: q.AnsId,
          IsDought: null,
          TimeTaken: q.TimeTaken
        }))
      };


      this._svc.POST(body, '/ManageMock/SubmitExam').subscribe(response => {
        if (response.result.toLowerCase() == 'success') {
          debugger
          //this.capture();
          this.Window_blur.unsubscribe();
          this.Window_focus.unsubscribe();
          this.ExamStatus = "ExamSubmited";
          this._svc.closeFullscreen();
          this._svc.Set_ExamStatus(false);
          localStorage.removeItem(this.ExamCode)
        }
        else
          this._svc.Notification("error", response.message);
      });
    }
    catch (e) {
    }
  }

  SaveFeedback() {
    if (this.feedbackForm.invalid) {
      this.feedbackForm.markAllAsTouched();
      //this.feedbackForm.get('Remarks').markAsTouched();
      return;
    }
    var _obj = this.feedbackForm.value;

    _obj.PowerPrepStatusId = this.PREP_ExamDetails.PowerPrepStatusId;
    this._svc.POST(_obj, "/ManageMock/Feedback").subscribe(response => {
      this._svc.Notification(response.result, response.message);
      if (response.result.toLowerCase() == 'success') {
        window.location.href = "/report";
      }
    });
  }

  async FaceMatching() {

    var destinationBase64 = await this._svc.captureImage(this._canvas, this._camera);
    this.msg = ""
    var _faceStatus = "";

    if (await this._svc.faceMatchWithBase64(this.PREP_UserInfo.profilePic, destinationBase64)) {
      _faceStatus = "Matched";
    } else {
      this.msg = "Face verification failed: the image does not match the student photo.";
      _faceStatus = "Not Matched";
    }

    setTimeout(() => {
      this._svc.resizeBase64Image(destinationBase64, 320, 240).then(resized => {

        var _obj = {
          ImagePath: resized,
          PowerPrepStatusId: this.PREP_ExamDetails.PowerPrepStatusId,
          FaceStatus: _faceStatus
        }
        this._svc.POST(_obj, "/ManageMock/FaceDetection").subscribe(response => {
          if (response.result.toLowerCase() == 'success') {
          }
        });
      });

    }, 100);
  }

  // getColorForOptionCorrectOrNot(_ques: any, opt: any) {
  //   var _class = 'border:1px  solid gray'
  //   if (_ques.AnsId == opt.OptionId && _ques.AnsId == _ques.CorrectAnsId)
  //     _class = 'border:8px  solid #5cb85c';
  //   else if (_ques.AnsId == opt.OptionId && _ques.AnsId != _ques.CorrectAnsId)
  //     _class = 'border:8px  solid red';
  //   return _class+';margin-top:10px;font-family: Times New Roman, Times, serif; font-size:13pt;cursor:pointer';
  // }
  getColorForOptionCorrectOrNot(_ques: any, opt: any): string {
    let borderColor = 'lightgray';

    if (_ques.AnsId === opt.OptionId) {
      borderColor = _ques.AnsId === _ques.CorrectAnsId ? '#5cb85c' : 'red';
    }

    return `border:3px solid ${borderColor}; 
          margin-top:10px; 
          font-family:"Times New Roman", Times, serif; 
          font-size:13pt; 
          cursor:pointer;`;
  }

  // disableRightClick(event: Event) {
  //   event.preventDefault();
  //   this._svc.Notification('error', 'Alert!');
  // }


  //Block right-click globally
  // @HostListener('document:contextmenu', ['$event'])
  // onRightClick(event: MouseEvent) {
  //   this.disableRightClick(event);
  // }

  //  Block keyboard shortcuts(Ctrl + S, Ctrl + P, Ctrl + U, F12)
  // @HostListener('document:keydown', ['$event'])
  // onKeyDown(event: KeyboardEvent) {
  //   if (
  //     (event.ctrlKey && ['s', 'p', 'u'].includes(event.key.toLowerCase())) ||
  //     event.key === 'F12'
  //   ) {
  //     this.disableRightClick(event);
  //   }
  // }

}









